import React from 'react';
import PropTypes from 'prop-types';
import useIntl from '@afosto/utils-react/intl/useIntl';
import useForm from '@afosto/utils-react/validation/useForm';
import Form from '@afosto/app-components-react/Form';
import TextField from '@afosto/app-components-react/TextField';
import LoadingWrapper from '@afosto/components-react/LoadingWrapper';
import CountrySelect from '@afosto/app-components-react/CountrySelect';
import validationSchema from './validations';
import translations from './translations';

const BillingAddressForm = ({ billingAddress, onSubmit, onCancel, countries: rawCountries }) => {
  const {
    address_line_1: addressLine1 = '',
    address_line_2: addressLine2 = '',
    postal_code: postalCode = '',
    country_code: country = '',
    city = '',
  } = billingAddress;

  const intl = useIntl();
  const countries = rawCountries.map(rawCountry => ({
    label: rawCountry.name,
    ...rawCountry,
  }));
  const formattedCountry = countries.find(({ value }) => value === country);
  const form = useForm({
    validationSchema,
    defaultValues: {
      addressLine1,
      addressLine2,
      postalCode,
      city,
      country: formattedCountry,
    },
    onCancel,
    onSubmit,
  });

  return (
    <LoadingWrapper isLoading={form.isSubmitting}>
      <Form form={form}>
        <TextField
          name="addressLine1"
          label={intl.formatMessage(translations.fields.addressLine1.label)}
          autoFocus
        />

        <TextField
          name="addressLine2"
          label={intl.formatMessage(translations.fields.addressLine2.label)}
        />

        <TextField
          name="postalCode"
          label={intl.formatMessage(translations.fields.postalCode.label)}
        />

        <TextField name="city" label={intl.formatMessage(translations.fields.city.label)} />

        <CountrySelect
          name="country"
          label={intl.formatMessage(translations.fields.country.label)}
          options={countries}
        />
      </Form>
    </LoadingWrapper>
  );
};

BillingAddressForm.propTypes = {
  billingAddress: PropTypes.object,
  onSubmit: PropTypes.func,
  onCancel: PropTypes.func,
  countries: PropTypes.array,
};

BillingAddressForm.defaultProps = {
  billingAddress: null,
  onSubmit: undefined,
  onCancel: undefined,
  countries: [],
};

export default BillingAddressForm;
